import { api, useConfig, AuthenticatorAttachmentType } from '@treezor/treezor-sca';

import { useCurrentSupportUser } from '@/features/dashboard-users/hooks/useCurrentSupportUser';

export function use2FaConfig() {
  const { config: dashboardConfig, username, id } = useCurrentSupportUser();

  const rpId = dashboardConfig.site.isLocal
    ? 'localhost'
    : new URL(dashboardConfig.api.oauth.redirectUri).hostname || 'localhost';
  const rpName = dashboardConfig.site.name || 'Treezor';

  const hints = dashboardConfig.settings['2fa'].hints;

  const config = useConfig({
    rp: {
      id: rpId,
      name: rpName,
    },
    authenticatorSelection: {
      authenticatorAttachment: dashboardConfig?.settings?.['2fa']?.attachment as AuthenticatorAttachmentType,
      userVerification: 'required',
      requireResidentKey: false,
      residentKey: 'preferred',
    },
    userVerification: 'required',
  });

  const user = {
    name: username,
    displayName: username,
  };

  const scaApi = api(config);

  return { config, user, supportUserId: id, scaApi, hints };
}
